import React from 'react'

//components
import Worker from './Worker'

function Table(props) {
    const workers = props.workers

    return (
        <div className="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Материал</th>
                        <th>Характ.</th>
                        <th>Мерна единица</th>
                        <th>Мин. количество</th>
                        <th className="option">
                            Опции
                    </th>
                    </tr>
                </thead>
                <tbody>
                    {workers.map(worker =>
                        <Worker
                            worker={worker}
                            handleEdit={props.handleEdit}
                        />
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default Table